import { UserPreferencesService } from '@csp/csp-common-user';
import { User } from '@csp/csp-common-model';
import { DialogActions } from '@csp/csp-web-ui';
import { FC } from 'react';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { useTrackException } from '../../../common/hooks/useTrackException';
import { refreshUserThunk } from '../../security/ducks/principalContextActions';
import { StaticContentService } from '../../../common/service/StaticContentService';
import { AlertDialog } from '../../../common/component/AlertDialog';

type Props = {
  user: User;
};

export const CloseoutTrackerModalComponent: FC<Props> = ({ user }) => {
  const commonButtonTexts = StaticContentService.getGenericBlock('webHcpCommonUserInterface', 'commonButton');
  const closeOutTexts = StaticContentService.getGenericBlock('webHcpStudyCloseout', 'tracker');

  const dispatch = useAppDispatch();
  const trackException = useTrackException();
  const onClose = async (): Promise<void> => {
    try {
      await UserPreferencesService.updateUserPreferences(user.userV1, { dismissCloseoutTrackerInfoDialog: true });
      dispatch(refreshUserThunk());
    } catch (e) {
      console.error(e);
      trackException(e);
    }
  };

  const dialogActions = <DialogActions confirmLabel={commonButtonTexts.button.ok.label} onConfirm={onClose} />;

  return (
    <AlertDialog
      header={closeOutTexts.header.text}
      description={closeOutTexts.body.text}
      onClose={onClose}
      open
      actions={dialogActions}
    />
  );
};
